import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import injectSheet from 'react-jss';
import compose from 'recompose/compose';
import { CONTRACT_SERIES } from 'constants/index';

import { TextField, CheckboxField, SelectField, PasswordField } from '@avinfors/redux-form-fields';
import { required } from 'shared/validationFields';

class LoginForm extends Component {
  render() {
    const { handleSubmit, submitOnEnter, classes, error, submitting, triggerPassRecoveryMode } =
      this.props;

    return (
      <Form onKeyDown={submitOnEnter(handleSubmit)} onSubmit={handleSubmit}>
        <Row form>
          <Col sm={4}>
            <FormGroup>
              <Label>Серия договора</Label>
              <div className='SelectFieldLg'>
                <Field
                  component={SelectField}
                  name='seria'
                  placeholder=''
                  validate={required.req}
                  options={CONTRACT_SERIES.map((s, i) => ({ code: i, name: s }))}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={8}>
            <FormGroup>
              <Label>Номер договора</Label>
              <Field component={TextField} name='number' validate={required.req} bsSize='lg' />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label>Пароль</Label>
          <Field
            component={PasswordField}
            name='password'
            validate={required.req}
            bsSize='lg'
            buttonColor='success'
          />
        </FormGroup>
        <Row className='no-gutters'>
          <Col xs={6}>
            <Field
              component={CheckboxField}
              name='remember'
              label={
                <span>
                  {' '}
                  Запомнить <span className='d-none d-sm-inline'>меня</span>
                </span>
              }
              type='switch'
            />
          </Col>
          <Col xs={6} className='text-right'>
            <div className={classes.recoverLink} onClick={triggerPassRecoveryMode}>
              Забыли пароль?
            </div>
          </Col>
        </Row>
        <FormGroup>
          <div className='text-danger'>
            {error.split('\n').map((item, i) => {
              return <div key={i}>{item}</div>;
            })}
          </div>
        </FormGroup>
        {!error && (
          <Row>
            <Col className='text-muted mb-2'>
              Уважаемый клиент! Вход в личный кабинет доступен после прохождения первичной
              регистрации во вкладке «Регистрация».
            </Col>
          </Row>
        )}
        <Button color='success' block onClick={handleSubmit} size='lg' disabled={submitting}>
          {!submitting ? 'Войти' : 'Вход...'}
        </Button>
      </Form>
    );
  }
}

LoginForm.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitOnEnter: PropTypes.func.isRequired,
  triggerPassRecoveryMode: PropTypes.func.isRequired,
  error: PropTypes.string
};

LoginForm.defaultProps = {
  error: ''
};

const styles = theme => ({
  recoverLink: {
    color: '#8695a8',
    '&:hover': {
      color: '#3069B2'
    },
    cursor: 'pointer'
  }
});

export default compose(
  reduxForm({ form: 'loginForm', destroyOnUnmount: false }),
  injectSheet(styles)
)(LoginForm);
